(() => {
  const playIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M8 5.5v13l11-6.5-11-6.5z"></path>
    </svg>`;

  const pauseAll = (currentVideo) => {
    document.querySelectorAll('video.kb-content-video').forEach((video) => {
      if (video !== currentVideo && !video.paused) video.pause();
    });
  };

  const getPlayer = (video) => {
    const player = video.closest('[data-kb-video-player]') || video.parentElement;
    if (!player) return null;
    player.classList.add('kb-video-player');
    player.setAttribute('data-kb-video-player', '');
    return player;
  };

  const getPlayButton = (player) => {
    let button = player.querySelector('[data-kb-video-play]');
    if (button) return button;

    button = document.createElement('button');
    button.type = 'button';
    button.className = 'kb-video-play';
    button.dataset.kbVideoPlay = 'true';
    button.setAttribute('aria-label', 'Play video');
    button.innerHTML = playIcon;
    player.appendChild(button);
    return button;
  };

  const setPlayingState = (player, video, isPlaying) => {
    player.dataset.kbVideoPlaying = isPlaying ? 'true' : 'false';
    const button = player.querySelector('[data-kb-video-play]');
    if (button) button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    if (isPlaying) {
      player.dataset.kbVideoStarted = 'true';
      video.controls = true;
    }
  };

  const bindVideo = (video) => {
    if (video.dataset.kbVideoBound === 'true') return;
    const player = getPlayer(video);
    if (!player) return;

    const button = getPlayButton(player);
    video.dataset.kbVideoBound = 'true';
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.playsInline = true;
    video.preload = 'metadata';
    video.controls = false;
    setPlayingState(player, video, false);

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });

    video.addEventListener('play', () => {
      pauseAll(video);
      setPlayingState(player, video, true);
    });
    video.addEventListener('pause', () => setPlayingState(player, video, false));
    video.addEventListener('ended', () => setPlayingState(player, video, false));
    video.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.intersectionRatio < 0.3 && !video.paused) video.pause();
      }, { threshold: [0, 0.3] });
      observer.observe(video);
    }
  };

  const bindVideos = (root = document) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('video.kb-content-video').forEach(bindVideo);
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.querySelectorAll('video.kb-content-video').forEach((video) => video.pause());
    }
  });

  bindVideos();
  document.addEventListener('shopify:section:load', (event) => bindVideos(event.target));
})();
